
import  axios  from 'axios';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";


export const LOAD_VEHICLE_DATA = 'vehicle/LOAD_VEHICLE_DATA';
export const DELETE_A_VEHICLE = 'vehicle/DELETE_A_VEHICLE';
export const SAVE_A_VEHICLE = 'vehicle/SAVE_A_VEHICLE';
export const UPDATE_A_VEHICLE = 'vehicle/UPDATE_A_VEHICLE';
export const CLEAR_A_VEHICLE_ERROR_MESSAGE = 'vehicle/CLEAR_A_VEHICLE_ERROR_MESSAGE';


export function clearVehicleErrorMsgInStore(){
    return {
        type: CLEAR_A_VEHICLE_ERROR_MESSAGE,
        
    }
}

export function loadVehicleDataInStore(argVehicleDataArray, argErrorMsg) {
    return {
        type: LOAD_VEHICLE_DATA,
        vehiclesData:argVehicleDataArray,
        errorMsg:argErrorMsg
    }
}
export function deleteAVehicleDataInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_VEHICLE,
        deleteVehicleResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAVehicleDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_VEHICLE,
        saveVehicleResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAVehicleDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_VEHICLE,
        updateVehicleResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/

//****************************************
//Below is for update a Stream
//****************************************

export function clearVehicleErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearVehicleErrorMsgInStore());
    }
}


export function updateAVehicle(argURL, argCamera) {
    return (dispatch, getState) => {
        const state = getState();
        updateAVehicleOnServer(argURL, argCamera, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveAVehicleDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("Farshid some error occured on updating a vehicles " +  errorObj.statusText + errorObj.status );
            dispatch(saveAVehicleDataInStore({}, errorObj));
        });
    }//end of return
}


function updateAVehicleOnServer( argURL, argCamera,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAVehicle(argURL, argCamera, argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //var errorObj = AppUtils.getErroStatusAndText(err);
                //console.log("Farshid some error occured on updating a vehicles " +  errorObj.statusText + errorObj.status );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAVehicle(argURL, argVehicle, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/vehicles
     */

    let baseUrl = argURL+"users/"+argUserId+"/vehicles/" +argVehicle.id ;
    console.log(" on posting a vehicleies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argVehicle, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAVehicle(argURL, argCamera) {
    return (dispatch, getState) => {
        const state = getState();
        saveAVehicleOnServer(argURL, argCamera,  state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveAVehicleDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error saving a vehicle" + errorObj.statusText + errorObj.status);
            dispatch(saveAVehicleDataInStore({}, errorObj));
        });
    }//end of return
}


function saveAVehicleOnServer( argURL, argCamera, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAVehicle(argURL, argCamera, argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a vehicles " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAVehicle(argURL, argCamera, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/vehicles
     */

    let baseUrl =  argURL+"users/"+argUserId+"/vehicles";
    console.log(" on posting a vehicleies the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera, {headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a vehicle
//****************************************
export function deleteAVehicle(argURL, argVehicleId) {
    return (dispatch, getState) => {
        const state = getState();
        deleteAVehicleOnServer(argURL, argVehicleId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){

            dispatch(deleteAVehicleDataInStore(deleteResponse, null));

        }, function(err){
            console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAVehicleDataInStore({}, err));
        });
    }//end of return
}


function deleteAVehicleOnServer( argURL, argStreamId, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAVehicle(argURL, argStreamId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on deleteing a vehicle " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAVehicle(argURL, argVehicleId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+argUserId+"/vehicles"+"/"+argVehicleId;
    console.log(" on deleteing a vehicle the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of vehicles

export function loadVehiclesData(argURL) {
    return (dispatch, getState) => {
        // grab current state
        const state = getState();
        //let tempToken = state.login.loginData.idToken
        //console.log("Hey Farshid the idToken is" + tempToken);

        getListOfVehicles(argURL, state.login.loginData.idToken, state.user.saveUserResp.id).then(function(vehiclesList){

            dispatch(loadVehicleDataInStore(vehiclesList, null));

    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
            dispatch(loadVehicleDataInStore([], err));
        });
    }//end of return
}

function getArrayOfGetsForListOfVehicles(argURL,  argIdToken, argUserId ){
  
    let baseUrl = argURL+"users/"+argUserId+"/vehicles";
    console.log(" on getting list of Vehicles  the URL is " + baseUrl );

    var arrayOfGets = [];
    let tokenStr= argIdToken;
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfVehicles( argURL, argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfVehicles(argURL, argIdToken, argUserId)).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Vehicles " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


function getVehicleDataFromRemoteServer( argURL, argVehiclesList  ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if(argVehiclesList != null){

            axios.all(getArrayOfGets(argURL, argVehiclesList )).then(function(responses){
                resolve(responses);

            }, function(err) {
                console.log("Farshid some error occured " + err.message);
                reject(err);
            });
        }
    });

    return returnPromise;
}

function getArrayOfGets(argURL, argFarmsList ){

    //let baseUrl =  "http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/METRIC_VALUES?";
    let baseUrl = argURL;

    /*

     I need to build something like this :

     http://innovasea-app-dev-1.eastus.cloudapp.azure.com:4567/GRAPHS/farm_summary?farmId=f1
     */

    var arrayOfGets = [];
    if(argFarmsList != null) {
        for (var i = 0; i < argFarmsList.length; i++) {
                let responseData = argFarmsList[i];
                //let responseData = singleResponse.data;
                //if((argMetricList[i].checked != null) && (argMetricList[i].checked == true) ) {
                let tempURl = baseUrl + "GRAPHS" + "/farm_summary?farmId=" + responseData.id;
                console.log("Farshid the Vehicle DATA URL is =" + tempURl);
                arrayOfGets.push(axios.get(tempURl));

            //}
        }
    }
    return arrayOfGets;


}

/*
export function loadVehicleData(argURL) {
    return (dispatch, getState) => {


        var arrayOfVehicleData=[];
        getListOfVehicles(argURL).then(function(vehiclesList){

            for(var z=0; z<vehiclesList.length; z++){

                let singleResponse = vehiclesList[z];
                let responseData = singleResponse.data;
                getVehicleDataFromRemoteServer(argURL,responseData ).then(function (farmsData){
                    for(var i=0; i<farmsData.length; i++) {
                        arrayOfVehicleData.push(farmsData[i].data);
                    }
                    dispatch(loadVehicleDataInStore(arrayOfVehicleData));

                }, function (err){
                    console.log("I had an error gettting Farms Data3333" + err);
                });

            }
    }, function(err){
        console.log("I had an error gettting Farms Data2" + err);
        });
    }//end of return
}
 */
